module.exports = __webpack_public_path__ + "static/AmandaJ-b625283661ff618d5361995788af595c.png";